export const kUnknownTileType = "Unknown"
